import { render, staticRenderFns } from "./GuestReservationCard.vue?vue&type=template&id=991d4fcc"
import script from "./GuestReservationCard.vue?vue&type=script&lang=js"
export * from "./GuestReservationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports